module.exports = __webpack_public_path__ + "static/media/AboutNewImage.2ee49b90.png";